import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';

export interface IGetAllSubscriptionTiersUseCase {
    execute(
        apiKey: string,
        country: string,
        device: string,
        productKey: string,
        identityToken: string,
        groupBy?: string,
        showAllSubscriptions?: string,
        apiVersion?: string
    ): Promise<any>;
}

export class GetAllSubscriptionTiersUseCase implements IGetAllSubscriptionTiersUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getAllSubscriptionTiersRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(
        apiKey: string,
        country: string,
        device: string,
        productKey: string,
        identityToken: string,
        groupBy?: string,
        showAllSubscriptions?: string,
        apiVersion?: string
    ): Promise<any> {
        const response = await this.getAllSubscriptionTiersRepository.getAllSubscriptionTiers(
            apiKey,
            country,
            device,
            productKey,
            identityToken,
            groupBy,
            showAllSubscriptions,
            apiVersion
        );
        return response.data;
    }
}
